import { render, staticRenderFns } from "./outmat_init.vue?vue&type=template&id=0e8b817c&scoped=true&"
import script from "./outmat_init.vue?vue&type=script&lang=js&"
export * from "./outmat_init.vue?vue&type=script&lang=js&"
import style0 from "./outmat_init.vue?vue&type=style&index=0&id=0e8b817c&scoped=true&lang=less&"
import style1 from "./outmat_init.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b817c",
  null
  
)

export default component.exports